import { Directive, ElementRef, HostListener, Input, Optional, OnInit, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appMascara]'
})
export class MascaraDirective implements OnInit, OnDestroy {
  @Input('appMascara') tipo: string = '';

  @Input() set unmask(val: boolean | string) {
    this._unmask = val === '' || val === true || val === 'true';
  }
  get unmask() { return this._unmask; }
  private _unmask = false;

  private sub: Subscription | undefined;

  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  ngOnInit() {
    this.aplicarInputMode();

    if (this.control && this.control.valueChanges) {
      this.sub = this.control.valueChanges.subscribe(val => {
        if (val) {
          const formatted = this.aplicarMascara(val);
          // Atualiza visualmente para a máscara correta sem disparar loop
          if (this.el.nativeElement.value !== formatted) {
            this.el.nativeElement.value = formatted;
          }
        }
      });
      
      // Formatar o valor inicial (delay curto para aguardar inicialização do formulário)
      setTimeout(() => {
        if (this.control!.value) {
          this.el.nativeElement.value = this.aplicarMascara(String(this.control!.value));
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  aplicarInputMode() {
    if (this.tipo === 'telefone') {
      this.el.nativeElement.setAttribute('inputmode', 'tel');
    } else if (this.tipo === 'cpf' || this.tipo === 'cep' || this.tipo === 'data') {
      this.el.nativeElement.setAttribute('inputmode', 'numeric');
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let val = event.target.value;
    let formatted = this.aplicarMascara(val);
    
    // Atualiza o valor visual em tela na hora
    this.el.nativeElement.value = formatted;
    
    // Calcula o valor real que irá para o Angular (com ou sem máscara)
    let finalVal = this._unmask ? formatted.replace(/\D/g, '') : formatted;
    
    if (this.control && this.control.control) {
      // Usar emitEvent: false para não causar loops desnecessários
      this.control.control.setValue(finalVal, { emitEvent: false });
    }
  }

  aplicarMascara(valor: string): string {
    if (!valor) return '';
    let v = String(valor).replace(/\D/g, '');
    if (!v) return '';

    switch (this.tipo) {
      case 'cpf':
        v = v.substring(0, 11);
        v = v.replace(/(\d{3})(\d)/, '$1.$2');
        v = v.replace(/(\d{3})(\d)/, '$1.$2');
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        break;
      case 'cep':
        v = v.substring(0, 8);
        v = v.replace(/(\d{5})(\d)/, '$1-$2');
        break;
      case 'data':
        v = v.substring(0, 8);
        if (v.length > 2 && v.length <= 4) {
            v = v.replace(/(\d{2})(\d{1,2})/, '$1/$2');
        } else if (v.length > 4) {
            v = v.replace(/(\d{2})(\d{2})(\d{1,4})/, '$1/$2/$3');
        }
        break;
      case 'telefone':
        v = v.substring(0, 11);
        if (v.length <= 10) {
          v = v.replace(/(\d{2})(\d)/, '($1) $2');
          v = v.replace(/(\d{4})(\d)/, '$1-$2');
        } else {
          v = v.replace(/(\d{2})(\d)/, '($1) $2');
          v = v.replace(/(\d{5})(\d)/, '$1-$2');
        }
        break;
    }
    return v;
  }
}
